export const DEFAULT_SCHEDULE_KEYS = {
  DEFAULT: "default",
  ALWAYS_ON: "always-on",
  ALWAYS_OFF: "always-off",
  OFFICE: "office"
};

export const DEFAULT_SCHEDULES = {
  [DEFAULT_SCHEDULE_KEYS.OFFICE]: {
    name: "workday",
    description: "50hr week",
    timezone: "/timezones/5e9c869a-1c36-da8a-24dc-b5ed986abde7",
    startAt: "2018-11-19",
    endAt: null,
    sunday: false,
    monday: true,
    tuesday: true,
    wednesday: true,
    thursday: true,
    friday: true,
    saturday: false,
    actions: [
      {
        description: "start action",
        at: "09:00:00",
        value: "start"
      },
      {
        description: "stop action",
        at: "19:00:00",
        value: "stop"
      }
    ]
  },
  [DEFAULT_SCHEDULE_KEYS.ALWAYS_ON]: {
    name: "always-on",
    description: "Always on"
  },
  [DEFAULT_SCHEDULE_KEYS.ALWAYS_OFF]: {
    name: "always-off",
    description: "Always off",
    timezone: "/timezones/5e9c869a-1c36-da8a-24dc-b5ed986abde7",
    startAt: "2018-11-19",
    endAt: null,
    sunday: false,
    monday: true,
    tuesday: true,
    wednesday: true,
    thursday: true,
    friday: true,
    saturday: false,
    actions: [
      {
        description: "stop action",
        at: "00:00:00",
        value: "stop"
      }
    ]
  },
  [DEFAULT_SCHEDULE_KEYS.DEFAULT]: {
    description: "Always on"
  }
};
